import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PublicLayout from '../components/layout/PublicLayout';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from './ProtectedRoute';
import Home from '../pages/Home';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import AdminDashboard from '../pages/Admin/AdminDashboard';
import DatabaseBuku from '../pages/Admin/DatabaseBuku'; // <-- IMPORT BARU
import ManajemenKategori from '../pages/Admin/ManajemenKategori';
import ManajemenMitra from '../pages/Admin/ManajemenMitra';
import ManajemenKomisi from '../pages/Admin/ManajemenKomisi';
import ManajemenMateri from '../pages/Admin/ManajemenMateri';
import SemuaPesanan from '../pages/Admin/SemuaPesanan';
import DaftarPelangganAdmin from '../pages/Admin/DaftarPelangganAdmin';
import MitraDashboard from '../pages/Mitra/MitraDashboard';
import InputPenjualan from '../pages/Mitra/InputPenjualan';
import KomisiPage from '../pages/Mitra/KomisiPage';
import RiwayatPesanan from '../pages/Mitra/RiwayatPesanan';
import MateriMitra from '../pages/Mitra/MateriMitra';
import DaftarPelanggan from '../pages/Mitra/DaftarPelanggan';
import DaftarBuku from '../pages/Mitra/DaftarBuku';

const AppRouter = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
      </Route>
      <Route 
        element={
          <ProtectedRoute allowedRoles={['admin', 'mitra']}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/semua-pesanan" element={<SemuaPesanan />} />
        <Route path="/admin/database-buku" element={<DatabaseBuku />} /> {/* <-- RUTE BARU */}
        <Route path="/admin/manajemen-kategori" element={<ManajemenKategori />} />
        <Route path="/admin/manajemen-komisi" element={<ManajemenKomisi />} />
        <Route path="/admin/manajemen-mitra" element={<ManajemenMitra />} />
        <Route path="/admin/manajemen-materi" element={<ManajemenMateri />} />
        <Route path="/admin/daftar-pelanggan" element={<DaftarPelangganAdmin />} />

        <Route path="/mitra/dashboard" element={<MitraDashboard />} />
        <Route path="/mitra/input-penjualan" element={<InputPenjualan />} />
        <Route path="/mitra/komisi" element={<KomisiPage />} />
        <Route path="/mitra/riwayat-pesanan" element={<RiwayatPesanan />} />
        <Route path="/mitra/materi" element={<MateriMitra />} />
        <Route path="/mitra/daftar-pelanggan" element={<DaftarPelanggan />} />
        <Route path="/mitra/daftar-buku" element={<DaftarBuku />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
